import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import store, {history} from "./store";
import {setupInterceptors} from "./api";
import ReactGA from 'react-ga'

setupInterceptors(store, history);

ReactGA.initialize([{
    trackingId: "UA-143537749-1",
    debug: true,
    gaOptions: {
    }
}]);


ReactDOM.render(
    <Provider store={store}> <App/> </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
